/**
 * Indicator license context hook.
 *
 * Reads the per-indicator licensing fields delivered by `GET /metadata`
 * (after fresh login, relogin, or any metadata refetch) into the shape
 * consumed by `indicator-license.ts`. Shared by `IndicatorPanel` (gating the
 * Add Indicator dropdown) and `ChartPanel` (revalidating indicators already
 * on the chart).
 */
import { useSelector, shallowEqual } from "react-redux";
import { IndicatorLicenseContext } from "../indicators/engine/indicator-license";

export function useIndicatorLicenseContext(): IndicatorLicenseContext {
  return useSelector((state: any) => ({
    licenseType: state.metadata?.dashboardState?.licenseType ?? "",
    indicatorsWithExpiry: state.metadata?.indicatorState?.indicatorsWithExpiry ?? [],
    indicatorList: state.metadata?.indicatorState?.indicatorList ?? [],
    indicatorExpiryDtMap: state.metadata?.indicatorState?.indicatorExpiryDtMap ?? {},
  }), shallowEqual);
}
